import React from "react";
import "./Modal.css";

const Modal = ({ isOpen, title, onClose, children, actions }) => {
  if (!isOpen) return null;

  return (
    <div className="pc-modal-backdrop" onClick={onClose}>
      <div className="pc-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pc-modal-header">
          <h2>{title}</h2>
          <button type="button" className="pc-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="pc-modal-body">{children}</div>

        {actions && <div className="pc-modal-footer">{actions}</div>}
      </div>
    </div>
  );
};

export default Modal;
